const Todos = {
  AtCustomer: "Todos.AtCustomer",
  TodoTypeHelpText: "Todos.TodoTypeHelpText",
  TodoOwnerHelpText: "Todos.TodoOwnerHelpText",
  TodoCreatedHelpText: "Todos.TodoCreatedHelpText",
  TodoCounterpartHelpText: "Todos.TodoCounterpartHelpText",
  TodoInformationHelpText: "Todos.TodoInformationHelpText",
  TodoStatusHelpText: "Todos.TodoStatusHelpText",
  TodoAmountHelpText: "Todos.TodoAmountHelpText",
  TodoDueDateHelpText: "Todos.TodoDueDateHelpText",
  AllCompleteMessage: "Todos.AllCompleteMessage",
  ShowAllTodos: "Todos.ShowAllTodos",
  AllCompleteTitle: "Todos.AllCompleteTitle",
  MessageFromWint: "Todos.MessageFromWint",
  DeadlineType_0: "Todos.DeadlineType_0",
  DeadlineType_1: "Todos.DeadlineType_1",
  DeadlineType_2: "Todos.DeadlineType_2",
  ConsequenceAction_0: "Todos.ConsequenceAction_0",
  ConsequenceAction_1: "Todos.ConsequenceAction_1",
  ConsequenceAction_2: "Todos.ConsequenceAction_2",
  ConsequenceAction_3: "Todos.ConsequenceAction_3",
  Urgency_0: "Todos.Urgency_0",
  Urgency_1: "Todos.Urgency_1",
  Urgency_2: "Todos.Urgency_2",
  TodoGroup_IncomingInvoice: "Todos.TodoGroup_IncomingInvoice",
  TodoGroup_Receipt: "Todos.TodoGroup_Receipt",
  TodoGroup_AccountingDocument: "Todos.TodoGroup_AccountingDocument",
  TodoGroup_Message: "Todos.TodoGroup_Message",
  TodoGroup_ReceivedByMail: "Todos.TodoGroup_ReceivedByMail",
  TodoGroup_RecurringRoutine: "Todos.TodoGroup_RecurringRoutine",
  TodoGroup_Salary: "Todos.TodoGroup_Salary",
  TodoGroup_Payment: "Todos.TodoGroup_Payment",
  TodoGroup_AgentSale: "Todos.TodoGroup_AgentSale",
  TodoGroup_CustomerInvoice: "Todos.TodoGroup_CustomerInvoice",
  TodoGroup_AnnualAccount: "Todos.TodoGroup_AnnualAccount",
  TodoGroup_K10: "Todos.TodoGroup_K10",
  TodoGroup_Other: "Todos.TodoGroup_Other",
  TodoGroup_ShareRegister: "Todos.TodoGroup_ShareRegister",
  TodoGroup_Tax: "Todos.TodoGroup_Tax",
  TodoGroup_RevenueReporting: "Todos.TodoGroup_RevenueReporting",
  AllCompanies: "Todos.AllCompanies",
  AllCompaniesSearchCompany: "Todos.AllCompaniesSearchCompany",
  AllCompaniesSortName: "Todos.AllCompaniesSortName",
  AllCompaniesSortTodoCount: "Todos.AllCompaniesSortTodoCount",
  AllCompaniesSortOverdue: "Todos.AllCompaniesSortOverdue",
  AllCompaniesAllDone: "Todos.AllCompaniesAllDone",
  AllCompaniesNoMatch: "Todos.AllCompaniesNoMatch",
  AllCompaniesMoreGroups: "Todos.AllCompaniesMoreGroups",
  AllCompaniesRefresh: "Todos.AllCompaniesRefresh",
  AllCompaniesRefreshedAt: "Todos.AllCompaniesRefreshedAt",
  AllCompaniesOverdueCount: "Todos.AllCompaniesOverdueCount",
  AllCompaniesGroupCount_IncomingInvoice: "Todos.AllCompaniesGroupCount_IncomingInvoice",
  AllCompaniesGroupCount_Receipt: "Todos.AllCompaniesGroupCount_Receipt",
  AllCompaniesGroupCount_AccountingDocument: "Todos.AllCompaniesGroupCount_AccountingDocument",
  AllCompaniesGroupCount_Message: "Todos.AllCompaniesGroupCount_Message",
  AllCompaniesGroupCount_ReceivedByMail: "Todos.AllCompaniesGroupCount_ReceivedByMail",
  AllCompaniesGroupCount_RecurringRoutine: "Todos.AllCompaniesGroupCount_RecurringRoutine",
  AllCompaniesGroupCount_Salary: "Todos.AllCompaniesGroupCount_Salary",
  AllCompaniesGroupCount_Payment: "Todos.AllCompaniesGroupCount_Payment",
  AllCompaniesGroupCount_AgentSale: "Todos.AllCompaniesGroupCount_AgentSale",
  AllCompaniesGroupCount_CustomerInvoice: "Todos.AllCompaniesGroupCount_CustomerInvoice",
  AllCompaniesGroupCount_AnnualAccount: "Todos.AllCompaniesGroupCount_AnnualAccount",
  AllCompaniesGroupCount_K10: "Todos.AllCompaniesGroupCount_K10",
  AllCompaniesGroupCount_Other: "Todos.AllCompaniesGroupCount_Other",
  AllCompaniesGroupCount_ShareRegister: "Todos.AllCompaniesGroupCount_ShareRegister",
  AllCompaniesGroupCount_Tax: "Todos.AllCompaniesGroupCount_Tax",
  AllCompaniesGroupCount_RevenueReporting: "Todos.AllCompaniesGroupCount_RevenueReporting",
  TodoCardName_IncomingInvoiceToApprove: "Todos.TodoCardName_IncomingInvoiceToApprove",
  TodoCardName_IncomingInvoiceFinalApproval: "Todos.TodoCardName_IncomingInvoiceFinalApproval",
  TodoCardName_IncomingInvoiceMissingApproval: "Todos.TodoCardName_IncomingInvoiceMissingApproval",
  TodoCardName_ReceiptDraft: "Todos.TodoCardName_ReceiptDraft",
  TodoCardName_ReceiptToApprove: "Todos.TodoCardName_ReceiptToApprove",
  TodoCardName_ReceiptSentBack: "Todos.TodoCardName_ReceiptSentBack",
  TodoCardName_InvoiceDraft: "Todos.TodoCardName_InvoiceDraft",
  TodoCardName_InvoiceOverdue: "Todos.TodoCardName_InvoiceOverdue",
  TodoCardName_InvoiceReminderFeeNotPaid: "Todos.TodoCardName_InvoiceReminderFeeNotPaid",
  TodoCardName_MissingDocument: "Todos.TodoCardName_MissingDocument",
  TodoCardName_Support: "Todos.TodoCardName_Support",
  TodoCardName_DocumentDraft: "Todos.TodoCardName_DocumentDraft",
  TodoCardName_ProfileRoutine: "Todos.TodoCardName_ProfileRoutine",
  TodoCardName_CustomerFeedback: "Todos.TodoCardName_CustomerFeedback",
  TodoCardName_PaymentSigningInformation: "Todos.TodoCardName_PaymentSigningInformation",
  TodoCardName_SalaryDraft: "Todos.TodoCardName_SalaryDraft",
  TodoCardName_SalaryDeviationReport: "Todos.TodoCardName_SalaryDeviationReport",
  TodoCardName_AgentSaleMissingInformation: "Todos.TodoCardName_AgentSaleMissingInformation",
  TodoCardName_PersonSalaryReport: "Todos.TodoCardName_PersonSalaryReport",
  TodoCardName_UnhandledBankPayments: "Todos.TodoCardName_UnhandledBankPayments",
  TodoCardName_StoppedPayment: "Todos.TodoCardName_StoppedPayment",
  TodoCardName_PausedPayments: "Todos.TodoCardName_PausedPayments",
  TodoCardName_QualifiedShareDividend: "Todos.TodoCardName_QualifiedShareDividend",
  TodoCardName_GenericVouchersSentBack: "Todos.TodoCardName_GenericVouchersSentBack",
  TodoCardName_Survey: "Todos.TodoCardName_Survey",
  TodoCardName_SalaryDeviationAndTimeLogReport: "Todos.TodoCardName_SalaryDeviationAndTimeLogReport",
  TodoCardName_WintSalaryTimeLogReport: "Todos.TodoCardName_WintSalaryTimeLogReport",
  TodoCardName_AnnualAccountsForCustomerApproval: "Todos.TodoCardName_AnnualAccountsForCustomerApproval",
  TodoCardName_SupplementaryMaterial: "Todos.TodoCardName_SupplementaryMaterial",
  TodoCardName_IncomingInvoiceSentBack: "Todos.TodoCardName_IncomingInvoiceSentBack",
  TodoCardName_UpdateNewBoardMembersData: "Todos.TodoCardName_UpdateNewBoardMembersData",
  TodoCardName_SalaryDeviationReportWithBusinessUnits: "Todos.TodoCardName_SalaryDeviationReportWithBusinessUnits",
  TodoCardName_ShareRegisterConfirmationToApprove: "Todos.TodoCardName_ShareRegisterConfirmationToApprove",
  TodoCardName_AgingIncomingInvoiceOverPaid: "Todos.TodoCardName_AgingIncomingInvoiceOverPaid",
  TodoCardName_AgingIncomingInvoiceLeftToPay: "Todos.TodoCardName_AgingIncomingInvoiceLeftToPay",
  TodoCardName_UnhandledSelfInvoice: "Todos.TodoCardName_UnhandledSelfInvoice",
  TodoCardName_AuditorReportToUpload: "Todos.TodoCardName_AuditorReportToUpload",
  TodoCardName_AuditorReportToSign: "Todos.TodoCardName_AuditorReportToSign",
  TodoCardName_AnnualReportSigningSteps: "Todos.TodoCardName_AnnualReportSigningSteps",
  TodoCardName_AnnualReportDocument: "Todos.TodoCardName_AnnualReportDocument",
  TodoCardName_GeneralMeetingDocument: "Todos.TodoCardName_GeneralMeetingDocument",
  TodoCardName_BolagsverketSubmission: "Todos.TodoCardName_BolagsverketSubmission",
  TodoCardName_AuditorAnnualReportSigningSteps: "Todos.TodoCardName_AuditorAnnualReportSigningSteps",
  TodoCardName_WintSalaryApprovalReport: "Todos.TodoCardName_WintSalaryApprovalReport",
  TodoCardName_RemovedDocumentDraft: "Todos.TodoCardName_RemovedDocumentDraft",
  TodoCardName_ExternalCompanyHoldings: "Todos.TodoCardName_ExternalCompanyHoldings",
  TodoCardName_ClassifiedReceiptTodo: "Todos.TodoCardName_ClassifiedReceiptTodo",
  TodoCardName_PreliminaryTaxUpdate: "Todos.TodoCardName_PreliminaryTaxUpdate",
  TodoCardName_BankPortalSigning: "Todos.TodoCardName_BankPortalSigning",
  TodoCardName_RevenueReportNotSubmitted: "Todos.TodoCardName_RevenueReportNotSubmitted",
  TodoCardSubTypeText_IncomingInvoiceToApprove: "Todos.TodoCardSubTypeText_IncomingInvoiceToApprove",
  TodoCardSubTypeText_IncomingInvoiceFinalApproval: "Todos.TodoCardSubTypeText_IncomingInvoiceFinalApproval",
  TodoCardSubTypeText_IncomingInvoiceMissingApproval: "Todos.TodoCardSubTypeText_IncomingInvoiceMissingApproval",
  TodoCardSubTypeText_ReceiptDraft: "Todos.TodoCardSubTypeText_ReceiptDraft",
  TodoCardSubTypeText_ReceiptToApprove: "Todos.TodoCardSubTypeText_ReceiptToApprove",
  TodoCardSubTypeText_ReceiptSentBack: "Todos.TodoCardSubTypeText_ReceiptSentBack",
  TodoCardSubTypeText_InvoiceDraft: "Todos.TodoCardSubTypeText_InvoiceDraft",
  TodoCardSubTypeText_InvoiceOverdue: "Todos.TodoCardSubTypeText_InvoiceOverdue",
  TodoCardSubTypeText_InvoiceReminderFeeNotPaid: "Todos.TodoCardSubTypeText_InvoiceReminderFeeNotPaid",
  TodoCardSubTypeText_MissingDocument: "Todos.TodoCardSubTypeText_MissingDocument",
  TodoCardSubTypeText_Support: "Todos.TodoCardSubTypeText_Support",
  TodoCardSubTypeText_DocumentDraft: "Todos.TodoCardSubTypeText_DocumentDraft",
  TodoCardSubTypeText_ProfileRoutine: "Todos.TodoCardSubTypeText_ProfileRoutine",
  TodoCardSubTypeText_CustomerFeedback: "Todos.TodoCardSubTypeText_CustomerFeedback",
  TodoCardSubTypeText_PaymentSigningInformation: "Todos.TodoCardSubTypeText_PaymentSigningInformation",
  TodoCardSubTypeText_SalaryDraft: "Todos.TodoCardSubTypeText_SalaryDraft",
  TodoCardSubTypeText_SalaryDeviationReport: "Todos.TodoCardSubTypeText_SalaryDeviationReport",
  TodoCardSubTypeText_AgentSaleMissingInformation: "Todos.TodoCardSubTypeText_AgentSaleMissingInformation",
  TodoCardSubTypeText_PersonSalaryReport: "Todos.TodoCardSubTypeText_PersonSalaryReport",
  TodoCardSubTypeText_UnhandledBankPayments: "Todos.TodoCardSubTypeText_UnhandledBankPayments",
  TodoCardSubTypeText_StoppedPayment: "Todos.TodoCardSubTypeText_StoppedPayment",
  TodoCardSubTypeText_PausedPayments: "Todos.TodoCardSubTypeText_PausedPayments",
  TodoCardSubTypeText_QualifiedShareDividend: "Todos.TodoCardSubTypeText_QualifiedShareDividend",
  TodoCardSubTypeText_GenericVouchersSentBack: "Todos.TodoCardSubTypeText_GenericVouchersSentBack",
  TodoCardSubTypeText_Survey: "Todos.TodoCardSubTypeText_Survey",
  TodoCardSubTypeText_SalaryDeviationAndTimeLogReport: "Todos.TodoCardSubTypeText_SalaryDeviationAndTimeLogReport",
  TodoCardSubTypeText_AnnualAccountsForCustomerApproval: "Todos.TodoCardSubTypeText_AnnualAccountsForCustomerApproval",
  TodoCardSubTypeText_SupplementaryMaterial: "Todos.TodoCardSubTypeText_SupplementaryMaterial",
  TodoCardSubTypeText_IncomingInvoiceSentBack: "Todos.TodoCardSubTypeText_IncomingInvoiceSentBack",
  TodoCardSubTypeText_UpdateNewBoardMembersData: "Todos.TodoCardSubTypeText_UpdateNewBoardMembersData",
  TodoCardSubTypeText_SalaryDeviationReportWithBusinessUnits: "Todos.TodoCardSubTypeText_SalaryDeviationReportWithBusinessUnits",
  TodoCardSubTypeText_ShareRegisterConfirmationToApprove: "Todos.TodoCardSubTypeText_ShareRegisterConfirmationToApprove",
  TodoCardSubTypeText_AgingIncomingInvoiceOverPaid: "Todos.TodoCardSubTypeText_AgingIncomingInvoiceOverPaid",
  TodoCardSubTypeText_AgingIncomingInvoiceLeftToPay: "Todos.TodoCardSubTypeText_AgingIncomingInvoiceLeftToPay",
  TodoCardSubTypeText_UnhandledSelfInvoice: "Todos.TodoCardSubTypeText_UnhandledSelfInvoice",
  TodoCardSubTypeText_AuditorReportToUpload: "Todos.TodoCardSubTypeText_AuditorReportToUpload",
  TodoCardSubTypeText_AuditorReportToSign: "Todos.TodoCardSubTypeText_AuditorReportToSign",
  TodoCardSubTypeText_AnnualReportSigningSteps: "Todos.TodoCardSubTypeText_AnnualReportSigningSteps",
  TodoCardSubTypeText_AuditorAnnualReportSigningSteps: "Todos.TodoCardSubTypeText_AuditorAnnualReportSigningSteps",
  TodoCardSubTypeText_WintSalaryApprovalReport: "Todos.TodoCardSubTypeText_WintSalaryApprovalReport",
  TodoCardSubTypeText_RemovedDocumentDraft: "Todos.TodoCardSubTypeText_RemovedDocumentDraft",
  TodoCardSubTypeText_ExternalCompanyHoldings: "Todos.TodoCardSubTypeText_ExternalCompanyHoldings",
  TodoCardSubTypeText_ClassifiedReceiptTodo: "Todos.TodoCardSubTypeText_ClassifiedReceiptTodo",
  TodoCardSubTypeText_PreliminaryTaxUpdate: "Todos.TodoCardSubTypeText_PreliminaryTaxUpdate",
  TodoCardSubTypeText_RevenueReportNotSubmitted: "Todos.TodoCardSubTypeText_RevenueReportNotSubmitted",
  TodoCardSubTypeText_BankPortalSigning: "Todos.TodoCardSubTypeText_BankPortalSigning",
  BankPortalSigning_Header: "Todos.BankPortalSigning_Header",
  BankPortalSigning_SubHeader: "Todos.BankPortalSigning_SubHeader",
  BankPortalSigning_PaymentsTitle: "Todos.BankPortalSigning_PaymentsTitle",
  K10Form: "Todos.K10Form",
  PreliminaryTaxUpdate_Header: "Todos.PreliminaryTaxUpdate_Header",
  PreliminaryTaxUpdate_Body: "Todos.PreliminaryTaxUpdate_Body",
  PreliminaryTaxUpdate_Body2: "Todos.PreliminaryTaxUpdate_Body2",
  PreliminaryTaxUpdate_TaxToPay: "Todos.PreliminaryTaxUpdate_TaxToPay",
  PreliminaryTaxUpdate_InterestFrom: "Todos.PreliminaryTaxUpdate_InterestFrom",
  PreliminaryTaxUpdate_Question: "Todos.PreliminaryTaxUpdate_Question",
  PreliminaryTaxUpdate_Accept: "Todos.PreliminaryTaxUpdate_Accept",
  PreliminaryTaxUpdate_Decline: "Todos.PreliminaryTaxUpdate_Decline",
  PreliminaryTaxUpdate_SubmitSuccess: "Todos.PreliminaryTaxUpdate_SubmitSuccess",
  PreliminaryTaxUpdate_Submit: "Todos.PreliminaryTaxUpdate_Submit",
  PreliminaryTaxUpdate_HowItWorks: "Todos.PreliminaryTaxUpdate_HowItWorks",
  PreliminaryTaxUpdate_HowItWorks_Bullet1: "Todos.PreliminaryTaxUpdate_HowItWorks_Bullet1",
  PreliminaryTaxUpdate_HowItWorks_Bullet2: "Todos.PreliminaryTaxUpdate_HowItWorks_Bullet2",
  PreliminaryTaxUpdate_HowItWorks_Paragraph: "Todos.PreliminaryTaxUpdate_HowItWorks_Paragraph",
  PreliminaryTaxUpdate_Deadline: "Todos.PreliminaryTaxUpdate_Deadline",
  }
export default Todos;